// extracted by mini-css-extract-plugin
export default {"navLink":"SidebarItem_navLink__Kt9zC","selected":"SidebarItem_selected__gWroh","active":"SidebarItem_active__rLRkY"};